var exports = {
  "kL": "x4c3adb35--a6cb46--container",
  "Zg": "x4c3adb35--a6cb46--emoji",
  "DD": "x4c3adb35--a6cb46--title",
  "VA": "x4c3adb35--a6cb46--subtitle",
  "XI": "x4c3adb35--a6cb46--action",
};

module.exports = exports;
